import React, { useEffect, useState } from 'react'
import Loadar from '../../../../common/loader/Loader';
import { selectedPaymentMethodForUser ,addPaymentMethodForUser, getActivePaymentMethod  } from '../../../../api/login/Login';
import { Button, Checkbox, Col, Row , message } from 'antd';
import { useParams } from 'react-router-dom';

const PaymentMethodPermisionUser = () => {
     const { id } = useParams();
     const [data, setData] = useState([]);
     const [selectedIds, setSelectedIds] = useState([]);
     const [loading, setLoading] = useState(false);

   const fetchData = async () => {
    setLoading(true)
    
      try {
        const response = await getActivePaymentMethod()
        setData(response.data.data || []);
      } catch (error) {
      } finally{
        setLoading(false)
      }
    };
    
    useEffect(() => {
      fetchData();
      fetchSelectedData()
    }, []);

    const fetchSelectedData = async()=>{
        let res  = await selectedPaymentMethodForUser(id)
          if(res?.statusCode === 200)
          {
            const activeTypes = res?.data?.activeTypes || [];
            const preSelectedIds = activeTypes?.map(item => item._id);
            setSelectedIds(preSelectedIds);
      
          }
          else{
            setSelectedIds([]);
          }
    }
    const onChange = checkedValues => {
        setSelectedIds(checkedValues);
      };


      const handleSubmit = async () => {
        const payload = {
          user_id : id,
          paymetIdArr: selectedIds
        };
        try {
          setLoading(true);
          const response =  await addPaymentMethodForUser(payload);
          response?.statusCode === 200 ? message.success(response?.message): message.error(response?.message);
           
       
        } catch (error) {
        } finally {
          setLoading(false);
        }
      };   

  return (
    <>
    {loading && <Loadar/>}
    <div className="approved-area">
    <h3>Payment Method</h3>
    </div>
    <div style={{marginTop:'20px'}}>

   
    <Checkbox.Group style={{ width: '100%' }} value={selectedIds} 
          onChange={onChange}>
    <Row gutter={[32, 16]} >
        {data?.map((item)=>
         <Col  key={item?._id} >
         <Checkbox value={item?._id}>{item?.type}</Checkbox>
       </Col>
        )}
     
    
    </Row>
  </Checkbox.Group>
  </div>
  <Button
                
                  type="primary" size="small"
                  style={{marginTop:'20px'}}
                  onClick={handleSubmit}
               >
                   Submit
               </Button>
    </>
  )
}

export default PaymentMethodPermisionUser